module.exports = __webpack_public_path__ + "static/media/org_phone.c1455ade.svg";